import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment';
import { Attachment } from './attachment.model';

@Injectable({
  providedIn: 'root'
})
export class AttachmentDialogService {

  constructor(public http: HttpClient) { }

  uploadFile(formData: FormData): Observable<HttpEvent<Attachment[]>> {
    return this.http.post<Attachment[]>(`${environment.apiUrl}/uploadfile`, formData, { reportProgress: true, observe: 'events' });
  }

  getFileUrl(fileId: Guid): string {
    return `${environment.apiUrl}/uploadfile/${fileId}`;
  }
}
